import { CurrentRevenueSharing, RevenueSharing, RevenueSharingCreateDTO } from 'core/revenueSharing/RevenueSharing';
import { AxiosInstance } from 'axios';
import client from './RestClient';

export interface RevenueSharingWebService {
  getRevenueSharings (): Promise<RevenueSharing[]>;
  getCurrentRevenueSharings (): Promise<CurrentRevenueSharing[]>;
  createRevenueSharing (revenueSharingCreateDTO: RevenueSharingCreateDTO): Promise<void>;
}

export class RestfulRevenueSharingWebService implements RevenueSharingWebService {
  restClient: AxiosInstance;

  constructor (restClient: AxiosInstance = client) {
    this.restClient = restClient;
  }

  async getRevenueSharings (): Promise<RevenueSharing[]> {
    const response = await this.restClient.get('/revenue-sharings');
    return response.data.records;
  }

  async getCurrentRevenueSharings (): Promise<CurrentRevenueSharing[]> {
    const response = await this.restClient.get('/revenue-sharings/current');
    return response.data.records;
  }

  async createRevenueSharing (revenueSharingCreateDTO: RevenueSharingCreateDTO): Promise<void> {
    await this.restClient.post('/revenue-sharings', revenueSharingCreateDTO);
  }
}
